/** @jsx jsx */
import React, { useContext, Fragment, useRef, useState, useEffect } from "react";
import { Link } from "gatsby";
import { MenuContext } from "@/context/menu-context";
import { LogoImage, NavLinks } from "@/data";
import { jsx } from '@emotion/react'

import Instagram from '../assets/images/lp/icons/instagram-m.svg'
import Facebook from '../assets/images/lp/icons/facebook-m.svg'
import Youtube from '../assets/images/lp/icons/youtube-m.svg'
import Whatsapp from '../assets/images/lp/icons/Whatsapp-m.svg'
import logoElos from '../assets/images/lp/icons/logoElos.svg'
import ArrowDown from '../assets/icons/arrow-down';

import { 
  showOverlayNav,
  popUpMenu,
  closepopUp,
  footerContacts,
  popUpSocial,
  logo2,
  popUpInner,
  dlMenuWrap,
  subMenu,
  popUp,
  actionsImgIconsSocialPopup,
  logoElosImg,
}  from '../assets/styles/PopUpMenu.styles'

import { 
  socialIcon,
}  from '../assets/styles/Header.styles'
import AccordionSection from "./CustomAccordion";

const PopupMenu = () => {
  const { menuStatus, updateMenuStatus } = useContext(MenuContext);
  const [menuClass, setMenuClass] = useState("scale-in-ver-top");
  const menuEl = useRef(null);

  const handleMenuClick = (e) => {
    e.preventDefault();
    if (menuStatus) {
      setMenuClass("scale-out-ver-top");
      setTimeout(() => {
        updateMenuStatus(false);
      }, 1000000);
    } else {
      updateMenuStatus(true);
      setMenuClass("scale-in-ver-top");
    }
  };

  const [activeAccordion, setActiveAccordion] = useState(null)
  const toggleAccordion = (eventKey) => {
    setActiveAccordion(activeAccordion === eventKey ? null : eventKey)
  }
  return (
    <div className="show-overlay-nav" css={showOverlayNav}>
      <div className={`popup popup__menu ${menuClass}`}  css={[popUp,popUpMenu]}>
          <a
            href=""
            id="close-popup"
            onClick={handleMenuClick}
            css={closepopUp}
            className="puff-in-center"
            ></a>
        <div className="container mobileContainer ">
          <div className="row">
            <div className="col-lg-12 text-left pl-4">
              <div css={logo2}>
                <Link className="puff-in-center"  to="/">
                  <img src={LogoImage.light} alt="" className="img-fluid" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-lg-12">
              <div css={popUpInner} className="popup-inner">
                <nav css={dlMenuWrap}
                  className="popup-menu dl-menu__wrap text-left"
                  ref={menuEl}
                >
                  <ul>
                    {NavLinks.map((links, index) => {
                      return (
                        <li
                          key={index}
                          className={`${
                            undefined !== links.subItems
                              ? "menu-item-has-children "
                              : ""
                          }`}
                        >
                         {links.subItems ? (
                          <div  style={{marginBottom: '10px'}}>
                            <AccordionSection
                              eventKey={String(links.name)}
                              callback={toggleAccordion}
                              isOpen={activeAccordion === String(links.name)}
                              title={links.name}
                              sizeTitle='35px'
                              mbDropDonw={0}
                            >
                                {links.subItems.map((subLinks, index) => (
                                  <li key={index}>
                                    <Link 
                                     onClick={() => {
                              
                                      if (menuStatus) {
                                        setMenuClass("scale-out-ver-top");
                                        setTimeout(() => {
                                          updateMenuStatus(false);
                                        }, 1000000); 
                                      } else {
                                        updateMenuStatus(true);
                                        setMenuClass("scale-in-ver-top");
                                      }
                                    }}
                                    className="linkspopup " to={subLinks.url}>{subLinks.name}</Link>
                                  </li>
                                ))}
                            </AccordionSection>
                          </div>
                          ) : (
                            <Link 
                            to={links.url} 
                            onClick={() => {

                              if (menuStatus) {
                                setMenuClass("scale-out-ver-top");
                                setTimeout(() => {
                                  updateMenuStatus(false);
                                }, 1000000);
                              } else {
                                updateMenuStatus(true);
                                setMenuClass("scale-in-ver-top");
                              }
                            }}
                          >
                            {links.name}
                          </Link>
                          
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-12 col-sm-12 col-xs-12 text-center text-md-left">
              <div css={footerContacts}>
                <a href="https://www.instagram.com/bertoni.elos/" target="_blank"><img src={Instagram}  /></a>
                <a css={socialIcon} href="https://www.facebook.com/bertonielos" target="_blank"><img src={Facebook} /></a>
                <a css={socialIcon} href="https://www.youtube.com/@rede_bertoni/featured" target="_blank"><img src={Youtube} /></a>
                <a css={socialIcon} href="https://api.whatsapp.com/send/?phone=554588442900&text&type=phone_number&app_absent=0" target="_blank"><img src={Whatsapp} /></a>
              </div>
            </div>
          </div> */}
           <div className="row">
            <div className="col-lg-12 col-sm-12 col-xs-12 text-center text-md-left ">
              <div className="puff-in-center" css={footerContacts}>
                  <img src={logoElos}  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupMenu;
